export default {
  tranid: 'momo Transaction code',
  recordId: 'Receiving account',
  partnerId: 'Payment account',
  user: 'Transfer account',
  partnerName: 'Account Name',
  amount: 'amount',
  desc: 'description',
  status: 'status',
  acktime: 'Time collection',
  createTime: 'Time pull record',
  merchantOrderNo: 'Merchant order number',
  systemOrderNo: 'System order number',
  comment: 'comment',
  no: "equipment number"

};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/momoLogs.js